import { RadioGroupProps as MuiRadioGroupProps, FormControl, NativeSelect, useMediaQuery, Input } from "@mui/material";
import { RadioOption } from "./RadioGroup";
import { Stack } from "@compass/core";
import { useEffect, useState } from "react";
import { FormQuestionWriteInTypes } from "pages/cobro/surveys/SurveyPage/Questions/SurveyQuestionEnum";
import CurrencyInput from "react-currency-input-field";

export type DropdownQuestionProps = MuiRadioGroupProps & {
  required?: boolean;
  widthPercent?: number;
  isDisabled: boolean;
  onChange: (option: RadioOption) => any;
  onOtherChange: (value: any, otherValue: string) => any;
  options: RadioOption[];
  value: any;
};

export type DropdownOption = {
  label: string;
  value: any;
};

export const DropdownQuestion = ({
  isDisabled,
  widthPercent,
  required,
  value,
  options,
  onChange,
  onOtherChange,
}: DropdownQuestionProps) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [selectedValue, setSelectedValue] = useState();
  const [selectedOption, setSelectedOption] = useState<RadioOption | null>();

  useEffect(() => {
    if (value != selectedValue) {
      setSelectedValue(value);

      let option = options.find((o) => o.value == value) || null;
      // console.log("the found option", option);
      setSelectedOption(option);
    }
  }, [value]);

  const currencyStyle = {
    color: "rgba(0, 0, 0, 0.87)",
    padding: "16.5px 14px",
    borderRadius: "5px",
    borderWidth: "1.25px",
    borderStyle: "solid",
    borderColor: "rgba(0, 0, 0, 0.20)",
  };

  const handleOtherChange = (option: RadioOption, otherValue: string) => {
    option.isOtherValue = otherValue;
    onOtherChange(option.value, option.isOtherValue);
  };

  const handleClick = (event: any) => {
    const answerId = event.target.value;
    const mappedOption = options.find((o) => o.value == answerId);
    onChange(mappedOption!);
  };

  return (
    <>
      {isMobile && (
        <FormControl required={required} disabled={isDisabled} sx={{ width: `${widthPercent || 100}%` }}>
          <Stack direction="column" spacing="md">
            <NativeSelect
              inputProps={{
                id: "uncontrolled-native",
              }}
              value={selectedValue}
              onChange={handleClick}
            >
              <option value=""></option>
              {options.map((o) => (
                <option value={parseInt(o.value.toString())}>{o.label!.replace(/<[^>]*>/g, "")}</option>
              ))}
            </NativeSelect>
            {selectedOption?.isOther && (
              <>
                {selectedOption.otherTypeId != FormQuestionWriteInTypes.Currency && (
                  <Input
                    style={{ marginTop: 10 }}
                    placeholder=""
                    disabled={isDisabled}
                    value={options.find((o) => o.value == value)?.isOtherValue}
                    onChange={(e) => {
                      handleOtherChange(selectedOption!, e.target.value);
                    }}
                    type={
                      selectedOption.otherTypeId == FormQuestionWriteInTypes.Number
                        ? "number"
                        : selectedOption.otherTypeId == FormQuestionWriteInTypes.Date
                        ? "date"
                        : "text"
                    }
                  />
                )}
                {selectedOption.otherTypeId == FormQuestionWriteInTypes.Currency && (
                  <CurrencyInput
                    style={currencyStyle}
                    id={selectedOption!.label}
                    disabled={isDisabled}
                    prefix="$"
                    defaultValue={undefined}
                    value={options.find((o) => o.value == value)?.isOtherValue || undefined}
                    decimalsLimit={2}
                    onValueChange={(value, name, values) => {
                      handleOtherChange(selectedOption!, value || "");
                    }}
                  />
                )}
              </>
            )}
          </Stack>
        </FormControl>
      )}
      {!isMobile && (
        <FormControl required={required} disabled={isDisabled} sx={{ minWidth: `${widthPercent || 100}%` }}>
          <Stack direction="column" spacing="md">
            <NativeSelect
              inputProps={{
                id: "uncontrolled-native",
              }}
              value={selectedValue}
              onChange={handleClick}
            >
              <option value=""></option>
              {options.map((o) => (
                <option value={parseInt(o.value.toString())}>{o.label!.replace(/<[^>]*>/g, "")}</option>
              ))}
            </NativeSelect>
            {selectedOption?.isOther && (
              <>
                {selectedOption.otherTypeId != FormQuestionWriteInTypes.Currency && (
                  <Input
                    style={{ marginTop: 10 }}
                    placeholder=""
                    disabled={isDisabled}
                    value={options.find((o) => o.value == value)?.isOtherValue}
                    onChange={(e) => {
                      handleOtherChange(selectedOption!, e.target.value);
                    }}
                    type={
                      selectedOption.otherTypeId == FormQuestionWriteInTypes.Number
                        ? "number"
                        : selectedOption.otherTypeId == FormQuestionWriteInTypes.Date
                        ? "date"
                        : "text"
                    }
                  />
                )}
                {selectedOption.otherTypeId == FormQuestionWriteInTypes.Currency && (
                  <CurrencyInput
                    style={currencyStyle}
                    id={selectedOption!.label}
                    disabled={isDisabled}
                    prefix="$"
                    defaultValue={undefined}
                    value={options.find((o) => o.value == value)?.isOtherValue || undefined}
                    decimalsLimit={2}
                    onValueChange={(value, name, values) => {
                      handleOtherChange(selectedOption!, value || "");
                    }}
                  />
                )}
              </>
            )}
          </Stack>
        </FormControl>
      )}
    </>
  );
};
